import { useNavigate } from "react-router-dom";
import { signOutCurrentSession } from "@/lib/authSession";

/**
 * Build the shared optimistic platform-admin sign-out action.
 * @param clearAuth - Auth-store action that immediately clears local session state.
 * @returns A handler that clears local auth, starts best-effort provider revocation, and opens login.
 */
export function useAdminSignOut(clearAuth: () => void): () => void {
  const navigate = useNavigate();

  return () => {
    clearAuth();
    void signOutCurrentSession().catch(() => {
      // Provider revocation is best-effort; local auth is already cleared.
    });
    void navigate("/login");
  };
}
